import React from 'react'
import SimpleSnackbar from './SimpleSnackbar'
import useNotification from '../../../../lib/hooks/useNotification'
import { NotificationType } from '../../../../types'

export type SimpleSnackbarWrapperProps = {
  /** Message to display */
  message: string
  /** Callback event when the Close button is clicked */
  onClose?: () => void
  /** Optional function to retry on error */
  onRetry?: () => void
  /** Show Refresh link */
  refresh?: boolean | undefined
  /** Optional aria compliant label on the Retry Button */
  retryAria?: string
  /** Type of notification */
  type: NotificationType
  /** Optional aria compliant label on the View Link */
  viewAria?: string | null
  /** Optional URL paired with View Link. View Link on display when this is provided */
  viewUrl?: string | null
}

const defaultProps: Omit<SimpleSnackbarWrapperProps, 'message' | 'type'> = {
  onClose: undefined,
  onRetry: undefined,
  refresh: false,
  retryAria: '',
  viewAria: '',
  viewUrl: ''
}

const SimpleSnackbarWrapper = ({
  message,
  onClose,
  onRetry,
  refresh,
  retryAria,
  type,
  viewAria,
  viewUrl
}: SimpleSnackbarWrapperProps) => {
  const { hideNotif } = useNotification()
  const handleClose = () => {
    if (onClose) {
      onClose()
    }
    hideNotif()
  }
  const retry = () => {
    if (onRetry) {
      onRetry()
      handleClose()
    }
  }

  return (
    <SimpleSnackbar
      message={message}
      onClose={handleClose}
      onRetry={onRetry ? retry : undefined}
      refresh={refresh}
      retryAria={retryAria}
      type={type}
      viewAria={viewAria}
      viewUrl={viewUrl}
    />
  )
}

SimpleSnackbarWrapper.defaultProps = defaultProps

export default SimpleSnackbarWrapper
